import { Directive, TemplateRef, inject, input } from '@angular/core';

@Directive({
  selector: '[appTableCell]',
  standalone: true,
})
export class TableCellDirective<T extends object> {
  public readonly templateRef = inject(TemplateRef);
  public appTableCellDataSource = input<readonly T[]>();

  public appTableCellKey = input.required<string>();

  public static ngTemplateContextGuard<T extends object>(
    _: TableCellDirective<T>,
    _context: unknown
  ): _context is {
    $implicit: T;
    index: number;
  } {
    return true;
  }
}
